<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import axios from 'axios'
import html2pdf from 'html2pdf.js'

export default {
  page: {
    title: 'Tenable Scans',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data () {
    return {
      updated: '',
      scans: [],
      title: 'Tenable Scans',
      loading: true,
      items: [
        {
          text: 'Home',
          href: '/'
        },
        {
          text: 'Tenable',
          href: '/tenable'
        },
        {
          text: 'Scans',
          active: true
        }
      ],
      // Column headers for the table
      columns: [
        {
          key: 'id',
          label: 'ID'
        },
        {
          key: 'name',
          label: 'Name'
        },
        {
          key: 'status',
          label: 'Status'
        },
        {
          key: 'creation_date',
          label: 'Creation Date'
        },
        {
          key: 'last_modification_date',
          label: 'Last Modified'
        },
        {
          key: 'owner',
          label: 'Owner'
        }
      ],
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      pdfConfig: {
        margin: 0.2,
        filename: 'Tenable Scan Report - Corona.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, dpi: 96, letterRendering: true, width: 1280 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
        pagebreak: { mode: 'css', before: '#page2el' },
        _pageBreak: { mode: 'avoid-all', before: '.break-page', after: '.break-page' }
      }
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      let that = this
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      const url = `${baseURL}/tenable/scans`

      that.loading = true

      axios.get(url)
        .then((response) => {
          // Check if response.data exists and has the expected format
          if (response.data && Array.isArray(response.data)) {
            that.scans = response.data
          } else if (response.data && response.data.scans && Array.isArray(response.data.scans)) {
            // Handle case where API returns data in a nested 'scans' property
            that.scans = response.data.scans
          } else {
            console.error('Unexpected API response format:', response.data)
            that.scans = []
          }
          const now = new Date()
          that.updated = now.toLocaleString()
          that.loading = false
        })
        .catch(function (error) {
          console.error('Error fetching scan data:', error)
          that.scans = []
          that.loading = false
        })
    },
    // Format the date from timestamp
    formatDate (timestamp) {
      if (!timestamp) return 'N/A'

      const date = new Date(timestamp * 1000)
      return date.toLocaleString()
    },
    // Get status class for badge styling
    getStatusClass (status) {
      switch (status) {
        case 'completed':
          return 'badge bg-success'
        case 'running':
          return 'badge bg-primary'
        case 'error':
          return 'badge bg-danger'
        case 'pending':
          return 'badge bg-warning'
        default:
          return 'badge bg-secondary'
      }
    },
    downloadPdf () {
      const element = document.getElementById('pdfcontent')
      html2pdf(element, this.pdfConfig)
    }

  }
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <div
      class="container"
      style="max-width: 1420px !important;"
    >
      <div class="row page-title align-items-center" />
      <div class="col-12 align-items-center">
        <b-button
          class="btn btn-primary btn-sm mr-1"
          variant="light"
          @click="downloadPdf"
        >
          Download PDF
        </b-button>
        <br><br>
        <div
          id="pdfcontent"
          style="width:1280px; break-after: page; clear: both;padding-left:20px;padding-right:20px;"
        >
          <section slot="pdf-content">
            <div class="card">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-4">
                  <h4 class="header-title">
                    Tenable Scans - Corona
                  </h4>
                  <span>Updated: {{ updated }}</span>
                </div>

                <template v-if="loading">
                  <!-- <b-button
                class="btn btn-primary btn-sm mr-1"
                variant="light"
                @click="downloadPdf"
              >
                Download PDF
              </b-button> -->
                </template>
                <!-- <template v-else>
              <span>
                Generating...
              </span>
            </template> -->
                <!-- Loading message -->
                <!-- <div
              v-if="loading"
              class="text-center py-5"
            >
              <p class="mt-2">
                Loading scans...
              </p>
            </div> -->

                <!-- Table content (only shown when not loading) -->
                <div
                  v-else
                  class="table-responsive"
                >
                  <!-- Debug info - can be removed after fixing -->
                  <div
                    v-if="scans.length === 0"
                    class="alert alert-info mb-3"
                  >
                    No scan data received from API. Please check the console for more details.
                  </div>

                  <table class="table table-centered table-hover mb-0">
                    <thead>
                      <tr>
                        <th
                          v-for="column in columns"
                          :key="column.key"
                        >
                          {{ column.label }}
                        </th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(scan, index) in scans"
                        :key="index"
                      >
                        <td>{{ scan.id }}</td>
                        <td>{{ scan.name }}</td>
                        <td>
                          <span :class="getStatusClass(scan.status)">
                            {{ scan.status }}
                          </span>
                        </td>
                        <td>{{ formatDate(scan.creation_date) }}</td>
                        <td>{{ formatDate(scan.last_modification_date) }}</td>
                        <td>{{ scan.owner }}</td>
                        <td>
                          <button
                            class="btn btn-sm btn-primary me-1"
                            title="View Details"
                          >
                            <i class="mdi mdi-eye" />
                          </button>
                          <button
                            class="btn btn-sm btn-info"
                            title="Download Report"
                          >
                            <i class="mdi mdi-download" />
                          </button>
                        </td>
                      </tr>
                      <tr v-if="scans.length === 0">
                        <td
                          :colspan="columns.length + 1"
                          class="text-center"
                        >
                          No scans found
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </layout>
</template>

<style scoped>
.table th {
  font-weight: 600;
}

.table td {
  vertical-align: middle;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}
</style>
